<template>
  <div class="CreateNewSimulation">
    <template>
      <v-btn
        :loading="dialog"
        @click="dialog = true"
        elevation="0"
        color="primary"
        class="elevation-0 ml-1 px-2"
        min-width="0"
        :title="is3d ? 'New 3D simulation (Gmsh + NGSolve)' : 'New 2D simulation (Meep)'"
        :aria-label="is3d ? 'New 3D simulation' : 'New 2D simulation'"
      >
        <v-icon dark small> {{ is3d ? "mdi-cube-outline" : "mdi-square-outline" }} </v-icon>
        <span class="ml-1">{{ is3d ? "3D" : "2D" }}</span>
      </v-btn>
    </template>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="text-center">
          <v-spacer></v-spacer>
          <v-img
            max-width="300"
            class="mb-3 mt-5 m-auto"
            src="/img/illustrations/files.svg"
          ></v-img>
          <v-spacer></v-spacer>
          <h2 class="text-center mx-auto">{{ is3d ? "New 3D simulation" : "New 2D simulation" }}</h2>
          <p class="mx-auto">This form is the start to you simulation view</p>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="title"
                outlined
                dense
                label="Title"
                hint="To find this simulation later"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="description"
                outlined
                dense
                label="Description"
              ></v-text-field>
            </v-col>
            <!-- Célula, resolução e tempo só existem no 2D; no 3D o domínio é criado automaticamente -->
            <template v-if="!is3d">
              <v-col cols="6" sm="3">
                <v-text-field outlined dense type="number" v-model="coordinates.x" label="Width X (µm)"></v-text-field>
              </v-col>
              <v-col cols="6" sm="3">
                <v-text-field outlined dense type="number" v-model="coordinates.y" label="Height Y (µm)"></v-text-field>
              </v-col>
              <v-col cols="6" sm="3">
                <v-text-field outlined dense type="number" v-model="resolution" label="Resolution (px/µm)"></v-text-field>
              </v-col>
              <v-col cols="6" sm="3">
                <v-text-field outlined dense type="number" v-model="until" label="Time (µm/c)"></v-text-field>
              </v-col>
              <v-col cols="12" class="pt-0">
                <p class="text-caption mb-0">You can change all of these later in Cell Properties.</p>
              </v-col>
            </template>
            <v-col v-else cols="12" class="pt-0">
              <p class="text-caption mb-0">
                3D scenes need no cell size: the air box around your geometries and sources is
                created automatically when you run.
              </p>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row dense>
              <v-col>
                <v-btn x-large block @click="dialog = false">
                  <v-icon left>mdi-close</v-icon>
                  Cancel
                </v-btn>
              </v-col>
              <v-col>
                <v-btn v-if="is3d"
                  x-large
                  block
                  :loading="loading"
                  color="primary"
                  @click="createNewSimulation3d"
                >
                
                  <v-icon left>mdi-plus</v-icon>
                  Create 3D simulation
                </v-btn>
                <v-btn v-else
                  x-large
                  block
                  :loading="loading"
                  color="primary"
                  @click="createNewSimulation"
                >
                
                  <v-icon left>mdi-plus</v-icon>
                  Create 2D simulation
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from "@/services/api";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import simulator3d from "@/services/simulator3d";

export default {
  name: "CreateNewSimulation",
  props: {
    is3d: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    title: "Untitled simulation",
    description: "Untitled Simulation Description",
    coordinates: {
      x: 16,
      y: 16,
      z: 0
    },
    resolution: 10,
    geometries: [],
    sources: [],
    default_material: 1,
    loading: false,
    scene_design:
      "https://satemrj.com.br/site/wp-content/plugins/penci-soledad-amp/assets/images/no-thumb.jpg",
    scene_simulation:
      "https://satemrj.com.br/site/wp-content/plugins/penci-soledad-amp/assets/images/no-thumb.jpg",
    plotOptions: {
      until: 20
    },
    textButton: ""
  }),
  mounted() {
    
  },
  methods: {
    createNewSimulation: function() {
      this.loading = true;
      var {
        title,
        author,
        resolution,
        description,
        scene_design,
        scene_simulation,
        default_material,
        geometries,
        sources,
        coordinates,
        plotOptions
      } = this;

      // console.log({
      //   title,
      //   author,
      //   resolution,
      //   description,
      //   scene_design,
      //   scene_simulation,
      //   default_material,
      //   geometries,
      //   sources,
      //   coordinates,
      //   plotOptions
      // });

      api
        .post("/", {
          title,
          description,
          coordinates,
          resolution,
          geometries,
          sources,
          scene_design,
          scene_simulation,
          author,
          default_material,
          plotOptions,
          until: plotOptions.until
        })
        .then(({ data: { err, _id } }) => {
          if (err) {
            Swal.fire({ title: "An error Appears xs2!", text: err });
            return;
          }

          this.$router.push("/simulator/" + _id);
        });
    },
    createNewSimulation3d: function() {
      this.loading = true;
      var {
        title,
        author,
        resolution,
        description,
        scene_design,
        scene_simulation,
        default_material,
        geometries,
        sources,
        // coordinates,
        // plotOptions
      } = this;

      // console.log({
      //   title,
      //   author,
      //   resolution,
      //   description,
      //   scene_design,
      //   scene_simulation,
      //   default_material,
      //   geometries,
      //   sources,
      //   // coordinates,
      //   // plotOptions
      // });

      simulator3d
        .post("/", {
          title,
          description,
          // coordinates,
          resolution,
          geometries,
          sources,
          scene_design,
          scene_simulation,
          author,
          default_material,
          // plotOptions,
          // until: plotOptions.until
        })
        .then(({ data: { err, _id } }) => {
          if (err) {
            Swal.fire({ title: "An error Appears xs!", text: err });
            return;
          }

          this.$router.push("/simulator3d/" + _id);
        });
    }
  },
  computed: {
    ...mapGetters("simulator", ["author"]),
    until: {
      get() {
        return this.plotOptions.until;
      },
      set(v) {
        this.plotOptions.until = v;
      }
    }
  }
};
</script>
<style>
.CreateNewSimulation {
  margin-right: 1rem;
}

</style>
